import React, { Component } from 'react';
import Main from './Main';
import './css/materialize.min.css';
import './css/materialicons.css';
import './App.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
require('moment/locale/it.js');

class App extends Component {
  render() {
    return (
      <MuiThemeProvider>
          <div className="App">
             <Main/>
          </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx